var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-table',{attrs:{"data":_vm.table.data,"columns":_vm.table.columns,"table-class":"text-left","thead-classes":"text-primary text-left"}})
}
var staticRenderFns = []

export { render, staticRenderFns }